import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Minus, Plus, Trash2 } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatRupiah, imageUrl } from "@/lib/api";

export default function CartSheet() {
  const { items, setQty, remove, total, cartOpen, setCartOpen } = useCart();

  const goCheckout = () => {
    setCartOpen(false);
    document.getElementById("checkout")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <Sheet open={cartOpen} onOpenChange={setCartOpen}>
      <SheetContent
        data-testid="cart-sheet"
        className="bg-[#FBF9F5] border-l border-[#E8E2D5] w-full sm:max-w-md flex flex-col"
      >
        <SheetHeader>
          <SheetTitle className="font-serif-display text-xl text-[#1E2B1D]">
            Keranjang Belanja
          </SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto mt-4 space-y-4 pr-1">
          {items.length === 0 && (
            <p data-testid="cart-empty" className="text-sm text-[#6B7C66] text-center py-10">
              Keranjang masih kosong. Pilih rangkaian bunga favorit Anda.
            </p>
          )}
          {items.map(({ product, qty }) => (
            <div
              key={product.id}
              data-testid={`cart-item-${product.id}`}
              className="flex gap-3 bg-white rounded-xl border border-[#E8E2D5] p-3"
            >
              <img
                src={imageUrl(product.image_url)}
                alt={product.name}
                className="w-16 h-16 rounded-lg object-cover bg-[#F4EFE6]"
              />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold text-[#1E2B1D] truncate">{product.name}</p>
                <p className="text-xs text-[#3D5A40] font-semibold mt-0.5">
                  {formatRupiah(product.price)}
                </p>
                <div className="flex items-center gap-2 mt-2">
                  <button
                    data-testid={`cart-qty-minus-${product.id}`}
                    onClick={() => setQty(product.id, qty - 1)}
                    className="w-6 h-6 rounded-md border border-[#D5CCBC] flex items-center justify-center text-[#3D5A40] hover:bg-[#F4EFE6]"
                  >
                    <Minus className="w-3 h-3" />
                  </button>
                  <span data-testid={`cart-qty-${product.id}`} className="text-xs font-bold w-5 text-center">
                    {qty}
                  </span>
                  <button
                    data-testid={`cart-qty-plus-${product.id}`}
                    onClick={() => setQty(product.id, Math.min(qty + 1, product.stock))}
                    className="w-6 h-6 rounded-md border border-[#D5CCBC] flex items-center justify-center text-[#3D5A40] hover:bg-[#F4EFE6]"
                  >
                    <Plus className="w-3 h-3" />
                  </button>
                </div>
              </div>
              <button
                data-testid={`cart-remove-${product.id}`}
                onClick={() => remove(product.id)}
                className="self-start text-[#A89F8D] hover:text-red-600 transition-colors"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t border-[#E8E2D5] pt-4 mt-4">
            <div className="flex justify-between items-center mb-4">
              <span className="text-xs uppercase tracking-wider text-[#7E8F7A]">Total Belanja</span>
              <span data-testid="cart-total" className="text-lg font-bold text-[#203120]">
                {formatRupiah(total)}
              </span>
            </div>
            <button
              data-testid="cart-checkout-btn"
              onClick={goCheckout}
              className="w-full py-3.5 rounded-xl bg-[#3D5A40] hover:bg-[#2E4530] text-[#FAF7EE] font-bold text-sm transition-colors shadow-md"
            >
              Lanjut ke Checkout
            </button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
